// The pipeline's two vocabularies in one place. They used to be bare strings in five files
// — plus an identity map in ScanStation whose only job was to spell the phases again — so a
// new state meant finding every literal by hand (the `label_unprinted` fix wave found four).

export const PHASES = {
  IDLE: 'idle',
  SCANNING: 'scanning',
  LABELING: 'labeling',
  PRINTING: 'printing',
  DONE: 'done',
  SCAN_FAILED: 'scan_failed',
  LABEL_FAILED: 'label_failed',
  // The operator released the station while a label was still in flight.
  CANCELLED: 'cancelled',
}

// The phases that name a status line of their own (`c2c_receiving.scan.status.*`); the two
// failures put the error there instead.
export const STATUS_PHASES = [PHASES.IDLE, PHASES.SCANNING, PHASES.LABELING, PHASES.PRINTING, PHASES.DONE]

export const OUTCOMES = {
  PENDING: 'pending',
  PRINTED: 'printed',
  // The label exists server-side but never reached the printer.
  LABEL_UNPRINTED: 'label_unprinted',
  LABEL_REPLAYED: 'label_replayed',
  LABEL_FAILED: 'label_failed',
}

// Outcomes whose next step is "generate the label", not "print it again".
export const NEEDS_LABEL_OUTCOMES = [OUTCOMES.PENDING, OUTCOMES.LABEL_FAILED]

// Outcomes that mean the guía EXISTS server-side. A later failure — a reprint that hits a
// 500, a network drop — must never overwrite one of these: the entry carries the shipping
// number and the links the operator falls back on, and downgrading it to `label_failed`
// would offer them "Generar guía" for a package that already has one.
export const TERMINAL_SUCCESS_OUTCOMES = [OUTCOMES.PRINTED, OUTCOMES.LABEL_REPLAYED, OUTCOMES.LABEL_UNPRINTED]
